import '@reach/dialog/styles.css';
import { FC } from 'react';
import { ModalProps, Styled } from './';

const Modal: FC<ModalProps> = ({ children, ...props }) => {
  return (
    <Styled.Overlay {...props}>
      <Styled.Content {...props} tabIndex={5}>
        {children}
      </Styled.Content>
    </Styled.Overlay>
  );
};

export default Modal;
